import React, { useState, useEffect, useMemo } from "react";
import { instance } from "../../axios";
import { rupees } from "../../helper";
import { BgLoader, TableZero, PageError } from "../../ui";
import { useNavigate, useOutletContext } from "react-router-dom";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Link, useLocation } from "react-router-dom"

import { Helmet } from "react-helmet";
import { MdOutlineArrowForwardIos } from 'react-icons/md'

export default function UploadDocs() {
  let navigate = useNavigate();
  const [state, setState] = useState({});
  const [loader, showLoader] = useState({});

  const [pstate, setTitle] = useOutletContext(); // <-- access context value



  const doclistModal = useModal('docs');


  const showDocs = (id, row) => {
    // setState({ ...state, modalb: true })
    doclistModal.show({ id: id }).then((res) => {

    });

  }

  const fetchData = () => {
    instance
      .get("/cust_doc_requests")
      .then(function (response) {

        setState({ ...state, ...response.data });

      })
      .catch(function (error) { })
      .then(function () { });

  }


  useEffect(() => {
    setTitle('Upload Documents')
    fetchData()
  }, []);


  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }



  return (
    <div>
      <Helmet>
        <title>Upload Documents</title>
        {pstate.company && pstate.company.logo && <link rel="icon" type="image/x-icon" href={pstate.company.logo}></link>}
      </Helmet>
      {state.items && state.items.length > 0 ? (
        <>

          <p>Pending Document Requests</p>
          <div className="pt-0">




            {state.items.map((adata, index) => (
              <div className="p-3 bg-white rounded mb-3 d-flex justify-content-between align-items-center" key={index} onClick={() => showDocs(adata.id)}>
                <div>
                  <p><span className="text-secondary">Date: </span>{adata.date}</p>
                  <p><span className="text-secondary">Task: </span>{adata.task}</p>
                  <p className="mb-0"><span className="text-secondary">Message</span><br></br>{adata.subject}</p>
                </div>
                <MdOutlineArrowForwardIos className="fs-1 text-primary" />

              </div>
            ))}


          </div>
        </>
      ) : state.items && state.items.length == 0 ? <TableZero title="open Document Requests" /> : (
        <BgLoader />
      )}
    </div>
  );
}
